import API from './api.js'

export default {
    async getSamplesAttachments(sampleId) {
        try {
            let response = await API.HTTPS.get('/samples/' + sampleId + '/attachments')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async postSampleAttachment(sampleId, data) {
        try {
            let response = await API.HTTPS.post('/samples/' + sampleId + '/attachments', data)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async sif(number) {
        try {
            let response = await API.HTTPS.get('/samples/sif/' + number)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async getSample(id) {
        try {
            let response = await API.HTTPS.get('/samples/' + id)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async postSample(data) {
        try {
            let response = await API.HTTPS.post('/samples', data)

            if (response.status === 200) {
                return { code: 0, data: response.data }
            }
            else {
                return { code: 1, data: null }
            }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async putSample(id, data) {
        try {
            let response = await API.HTTPS.put('/samples/' + id, data)

            if (response.status === 200) {
                return { code: 0, data: response.data }
            }
            else {
                return { code: 1, data: null }
            }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async deleteSample(id) {
        try {
            let response = await API.HTTPS.delete('/samples/' + id)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async concludeSample(id, data) {
        try {
            let response = await API.HTTPS.put('/samples/' + id + '/conclude', data)

            if (response.status === 200) {
                return { code: 0, data: response.data }
            }
            else {
                return { code: 1, data: null }
            }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async createProtocol(id) {
        try {
            let response = await API.HTTPS.get('/samples/' + id + '/protocol')

            if (response.status === 200) {
                return { code: 0, data: response.data }
            }
            else {
                return { code: 1, data: null }
            }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async changeSampleLock(id, locked) {
        try {
            let response = await API.HTTPS.get('/samples/' + id + '/lock?locked=' + (locked ? 'true' : 'false'))

            if (response.status === 200) {
                return { code: 0, data: response.data }
            }
            else {
                return { code: 1, data: null }
            }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async sendSample(id) {
        try {
            let response = await API.HTTPS.get('/samples/' + id + '/send')

            if (response.status === 200) {
                return { code: 0, data: response.data }
            }
            else {
                return { code: 1, data: null }
            }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async markSampleToDownloadFromALS(id, data) {
        try {
            let response = await API.HTTPS.put('/samples/' + id + '/marktodownloadfromals', data)

            if (response.status === 200) {
                return { code: 0, data: response.data }
            }
            else {
                return { code: 1, data: null }
            }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    }
}